<template>
  <div>
    <WrapperContent>
      <b-table
        ref="tableComponent"
        :header="header"
        :headers="headers"
        :columns="columns"
        :sort="'id'"
        :uri="tableUri"
      />
    </WrapperContent>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'ReportAppList',
  data: () => ({
    uri: 'financial-report/all',
    header: 'Финансовые отчеты',
    headers: [
      {name: 'Название', filter: {type: 'text', field: 'name', operator: ':'}, minWidth: 115},
      {
        name: 'Описание',
        filter: {type: 'text', field: 'description', operator: ':', position: 'left-top'},
        minWidth: 175
      },
      {name: '', filter: {type: 'clear'}}
    ],
    columns: [
      {name: 'name', type: String},
      {name: 'description', type: String},
      {name: 'download', type: 'download'}
    ]
  }),
  computed: {
    ...mapState({
      selectedCommunityId: state => state.community.selectedCommunityId
    }),
    tableUri() {
      return this.uri + '/' + this.selectedCommunityId
    }
  }
}
</script>

<style scoped></style>
